// extracted by mini-css-extract-plugin
module.exports = {"picWrap":"oss-image_picWrap_1x_M0"};